

















































import { defineComponent } from '@vue/composition-api';
import TtamALink from 'src/components/common/a-link/a-link.vue';

const name = 'ttam-material-upload-progress';

export default defineComponent({
  name,

  components: { TtamALink },

  props: {
    count: { type: Number, default: 0 },
    progress: { type: Number, default: 0 },
    isUploading: { type: Boolean, default: true },
    isUploadFail: { type: Boolean, default: false },
    isPendant: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    function onCancel() {
      emit('cancel');
    }

    function onClose() {
      emit('close');
    }

    function onReTry() {
      emit('retry');
    }

    return {
      onClose,
      onCancel,
      onReTry,
    };
  },
});
